const Method = (props) => {
   return (
      <div className="list-cart-container shipment-method ">
         <div className="title-container">
            <div className="svg-next-icon icon-title" >
            </div><span className="title">Phương thức vận chuyển</span>
         </div>
         <div className="shipping-method-container">
            <div className="item-shipping-method-container first-item">
               <div className="app-next-input-radio">
                  <label className="app-next-label--switch" for="app-radio-43">
                     <div title="Giao hàng tận nơi" className="title-shipping">Giao hàng tận nơi</div>
                     <div className="fee-shipping">0 ₫</div>
                  </label>
                  <input type="radio" id="app-radio-43" className="app-next-radio" checked={true} />
                  <span className="app-next-radio--styled"></span>
               </div>
            </div>
         </div>
      </div>
   );
}
export default Method